"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nprogressBaseTheme = function (_breakpoints) { return ({
    "@global": {
        "#nprogress": { pointerEvents: "none" },
        "#nprogress .bar": {
            position: "fixed",
            zIndex: 12000,
            top: "0",
            left: "0",
            width: "100%",
            height: "4px"
        },
        "#nprogress .peg": {
            display: "block",
            position: "absolute",
            right: "0px",
            width: "100px",
            height: "100%",
            boxShadow: "0 0 10px #fff, 0 0 12px #fff",
            opacity: 1,
        },
        ".nprogress-custom-parent": { overflow: "hidden", position: "relative" },
        ".nprogress-custom-parent #nprogress .spinner, .nprogress-custom-parent #nprogress .bar": {
            position: "absolute"
        }
    }
}); };
exports.default = nprogressBaseTheme;
//# sourceMappingURL=nprogress.js.map